import { classNames } from "@greeter/util";
import React, { useEffect, useState } from "react";

import css from "./HighlightSpan.module.scss";

export type HighlightSpanProps = React.HTMLProps<HTMLSpanElement>;

export const HighlightSpan: React.FC<HighlightSpanProps> = ({
  className,
  ...props
}) => <span {...props} {...classNames(className, css.HighlightSpan)} />;
